import React from 'react'
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';
const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={`${className} faright`} onClick={onClick}>
          <CIcon icon="fa-right"></CIcon>
        </div>
    )
}


NextArrow.propTypes = {
     onClick: PropTypes.func,
     className: PropTypes.string,
};

export default NextArrow